import { useFields } from "../../hooks/use-fields";
import Input from "../Input";
import { Close } from "../Icons";
import styled from "styled-components/macro";
import { IconButton } from "../Button";
import Tooltip from "../Tooltip";
import { OnChange } from "../../hooks/use-optional-state";
import { EditableCampaignKeyword } from ".";

type Props = {
  value: EditableCampaignKeyword;
  onChange: OnChange<EditableCampaignKeyword>;
  onRemove: () => void;
};

function Keyword({ value, onChange, onRemove }: Props) {
  const { errors = {} } = value;
  const { field } = useFields({ value, onChange });

  return (
    <Container>
      <Row>
        <Input
          placeholder="Keyword"
          label=""
          {...field("keyword")}
          error={errors.keyword}
        />
        <IconButtonContainer>
          <Tooltip label="Remove Keyword">
            <IconButton onClick={onRemove}>
              <Close />
            </IconButton>
          </Tooltip>
        </IconButtonContainer>
      </Row>
    </Container>
  );
}

export default Keyword;

const IconButtonContainer = styled.div``;

const Container = styled.div`
  ${Input} {
    flex-grow: 1;
  }
  ${IconButtonContainer} {
    margin-left: 10px;
    transform: translateY(-9px);
  }
`;

const Row = styled.div`
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;
